module.exports = __webpack_public_path__ + "media/customizations/woodcreek/logo-new-5f2191885fca4d48a354d742d9552c75.png";